export default __webpack_public_path__ + "static/media/imgDarkEnQUALGO.05c7958c.png";